module.exports = __webpack_public_path__ + "img/moon.7736705.png";